import * as React from 'react';
import classnames from 'classnames';

import {IContentBlock} from 'features/blocks/types';
import BlockFactory from 'features/blocks/block-factory';

import './style.scss';

interface Props {
    id: string;
    blocks?: IContentBlock<unknown>[];
    children?: React.ReactNode[];
    className?: string;
}

export const PromotionBlockGrid: React.FunctionComponent<Props> = ({id, blocks, children, className}) => {
    const getBlock = (componentName: string) => {
        return BlockFactory(componentName);
    };

    const gridClasses = classnames('promotion-block-grid', className, {
        'promotion-block-grid--one': ((blocks && blocks.length == 1) || (children && children.length == 1)),
        'promotion-block-grid--two': ((blocks && blocks.length == 2) || (children && children.length == 2)),
        'promotion-block-grid--full': ((blocks && blocks.length > 2) || (children && children.length > 2)),
    });

    return (
        <React.Fragment>
            {((blocks && blocks.length > 0) || (children && children.length > 0)) &&
                <div className={gridClasses}>
                    {blocks && blocks.length > 0 && blocks.map((block, index) => {
                        const BlockComponent = getBlock(block.component);

                        if(typeof BlockComponent === 'undefined') {
                            console.error('Block does not exist', block.component);
                            return null;
                        }

                        return (
                            <BlockComponent
                                key={`${id}-${block.component}-${index}`}
                                component={block.component}
                                renderStyle={block.renderStyle}
                                data={block.data}
                                index={index}
                            />
                        );
                    })}
                    {children && children}
                </div>
            }
        </React.Fragment>
    )
};
